export default __webpack_public_path__ + "assets/logo_horizontal_nav.png";